import { createContext } from 'react'

import { type AllStepsData } from '../steps'

type SophisticatedFormStepContext = {
  onCompleted(formData: AllStepsData): void
}

export const SophisticatedFormStepContext =
  createContext<SophisticatedFormStepContext | null>(null)
export const SophisticatedFormStepProvider =
  SophisticatedFormStepContext.Provider
